import { useTranslate } from '@refinedev/core';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { PaymentIntent, StripeError } from '@stripe/stripe-js';
import { Alert, Button, Form } from 'antd';
import { useState } from 'react';

interface IPaymentFormProps {
    onSuccess?: (paymentIntent?: PaymentIntent) => void;
    onError?: (error?: StripeError) => void;
}

const PaymentForm: React.FC<IPaymentFormProps> = ({ onSuccess, onError }) => {
    const stripe = useStripe();
    const elements = useElements();
    const t = useTranslate();

    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleSubmit = async (event: any) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setLoading(true);

        const { error } = await stripe.confirmSetup({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: window.location.href,
            },
        });

        if (error) {
            console.log('error', error);
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            setErrorMessage(error.message as string);

            onError && onError(error);
            setLoading(false);
            return;
        }

        onSuccess && onSuccess();

        setLoading(false);
    };

    return (
        <Form onFinish={handleSubmit}>
            <PaymentElement />
            <Form.Item>
                <Button
                    className="w-full center mt-3"
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                >
                    {t('onboarding.next')}
                </Button>
            </Form.Item>
            {errorMessage && (
                <div className="mt-4">
                    <Alert message={errorMessage} type="error" />
                </div>
            )}
        </Form>
    );
};

export default PaymentForm;
